import { type IstanzaSezioneDati } from '@framework/api-client/api/backoffice/schemas/istanzaSezioneDati.ts';
import { type YupAnyObjectSchema } from '@framework/validation/YupObjectSchema.ts';
import { useMemo } from 'react';
import { type IEngineValidationContext } from '../../../engine/engine-validation/IEngineValidationContext.ts';
import { getDeclarationsInitialValues } from '../../declarations/getDeclarationsInitialValues.ts';

export interface IProcedureInitialValuesParams {
  declarations: IstanzaSezioneDati[] | null | undefined;
  schema: YupAnyObjectSchema;
  validationContext: IEngineValidationContext | null | undefined;
}

/**
 * Hook per la gestione dei valori iniziali del procedimento
 * in `/procedures/list/:id`. I valori mostrati sono statici.
 */
export function useProcedureInitialValues(
  params: IProcedureInitialValuesParams,
) {
  const { declarations, schema, validationContext } = params;

  const initialValues = useMemo(() => {
    if (!declarations) {
      return schema.cast({}, { assert: false, context: validationContext });
    }

    const declarationValues = getDeclarationsInitialValues(
      declarations,
      schema,
    );

    return schema.cast(declarationValues, {
      assert: false,
      context: validationContext,
    });
  }, [declarations, schema, validationContext]);

  return initialValues;
}
